import get from 'lodash/get';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {updatePageNumberForResourceAction} from 'resources/actions';
import {breakImagesPageName} from 'pages/EditBreak/utils';
import PagingBar from 'components/common/PagingBar';
import {clone, pageCount} from 'utils/DBUtils';
import {emptyPage} from "classes/state/ResourceState";

const mapStateToProps = state => {
  const {page, total, count, content} = state.resources.resourcePages[breakImagesPageName] || clone(emptyPage);
  return {
    currentPage: page,
    count: pageCount(total, count),
    maxPages: 10,
    total: total,
    numOfItemsOnPage: get(content, 'length', 0)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onPageSelected: page => updatePageNumberForResourceAction(breakImagesPageName, page),
  onNextClicked: currentPage => updatePageNumberForResourceAction(breakImagesPageName, currentPage+1),
  onPreviousClicked: currentPage => updatePageNumberForResourceAction(breakImagesPageName, currentPage-1)
}, dispatch);

const ImageUploaderAccordionPagingBar = connect(mapStateToProps, mapDispatchToProps)(PagingBar);

export default ImageUploaderAccordionPagingBar;



// WEBPACK FOOTER //
// ./public/components/images/ImageUploaderAccordionPagingBar.js